export default "__VITE_ASSET__7fb22cc9__"